import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';

import {Observable} from 'rxjs';
import {environment} from "@environments/environment";
import {AuthService} from "@core/authentication/auth.service";
import {REQUEST_HEADER_APP_VERSION, REQUEST_HEADER_AUTHORIZATION} from "@core/constants";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    @Inject(AuthService) private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiUrl = req.url.startsWith(environment.baseUrlApi);
    // Ads portal gắn token riêng qua AdsAuthInterceptor
    if (!isApiUrl || environment.isAdsModule) {
      return next.handle(req);
    }

    const headers: { [name: string]: string } = {
      [REQUEST_HEADER_AUTHORIZATION]: this.authService.getAuthorizationToken(),
      [REQUEST_HEADER_APP_VERSION]: environment.apiVersion.toString()
    }
    req = req.clone({
      setHeaders: headers
    })

    return next.handle(req);
  }
}
